<form [formGroup]="evaluationForm">
  <div class="container-fluid body-tab" [style.height]="(dynamicHeight) + 'px'">

    <div class="row-information">
      <label class="title-information ng-binding">Thông tin khởi tạo </label>
      <div class="form-group row">
        <label class="col-xl-2 col-form-label">{{ 'Ngày học' | translate }} <span class="required-field"> (*)</span></label>
        <div class="col-xl-4">

          <ejs-datepicker formControlName="NgayHoc"
                          placeholder="DD/MM/YYYY"
                          format="dd/MM/yyyy">
          </ejs-datepicker>
          <small class="text-danger" *ngIf="evaluationForm.get('NgayHoc').touched && evaluationForm.get('NgayHoc').invalid">
            {{ 'Ngày học không được để trống' | translate }}
          </small>
        </div>
        <label class="col-xl-2 col-form-label">{{ 'Điểm danh' | translate }}</label>
        <div class="col-xl-4">
          <ng-select [items]="attendanceOptions"
                     bindLabel="name"
                     bindValue="id"
                     formControlName="DiemDanh"
                     placeholder="{{ 'Chưa chọn trạng thái điểm danh' | translate }}">
          </ng-select>
          <small class="text-danger" *ngIf="evaluationForm.get('DiemDanh').touched && evaluationForm.get('DiemDanh').invalid">
            {{ 'Attendance is required' | translate }}
          </small>
        </div>
      </div>
      <!-- Course Content Field -->
      <div class="row">
        <div class="col-12 mb-3">
          <label class="control-label">{{ 'Nội dung bài học' | translate }}<span class="required-field"> (*)</span></label>

          <ejs-richtexteditor style="background-color:white" height='270px' #toolsRTE id='alltoolRTE_ch'
                              [toolbarSettings]='tools' [showCharCount]='true'
                              formControlName="NoiDungBaiHoc"
                              [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings'
                              [quickToolbarSettings]='quickToolbarSettings'
                              (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
          </ejs-richtexteditor>
        </div>
      </div>
    </div>

    <div class="row-information">
      <!-- Today Performance Field -->
      <div class="row">
        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Đánh giá buổi học' | translate }}</label>
          <ng-select [items]="todayPerformanceOptions"
                     bindLabel="Ten"
                     bindValue="Id"
                     formControlName="TodayPerformance"
                     placeholder="{{ 'Chọn đánh giá' | translate }}">
          </ng-select>
        </div>
        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Điểm' | translate }}</label>
          <input type="number" class="form-control" formControlName="Diem" step="0.01" min="0" max="100" placeholder="{{ 'Nhập điểm' | translate }}">
        
        </div>
      </div>

      <!-- Class Performance Fields -->
      <div class="row">
        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Biểu hiện trong lớp' | translate }}</label>
          <ng-select [items]="classPerformanceOptions"
                     [multiple]="true"
                     bindLabel="Ten"
                     bindValue="Id"
                     formControlName="ClassPerformance"
                     placeholder="{{ 'Chọn biểu hiện' | translate }}">
          </ng-select>
        </div>
        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Biểu hiện khác' | translate }}</label>
          <input type="text" class="form-control" formControlName="BieuHienTrongLopKhac" />
        </div>
      </div>

      <!-- Areas for Improvement Fields -->
      <div class="row">
        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Kỹ năng cần cải thiện' | translate }}</label>
          <ng-select [items]="needImprovementOptions"
                     [multiple]="true"
                     bindLabel="Ten"
                     bindValue="Id"
                     formControlName="NeedImprovement"
                     placeholder="{{ 'Chọn kỹ năng' | translate }}">
          </ng-select>
        </div>

        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Kỹ năng khác' | translate }}</label>
          <input type="text" class="form-control" formControlName="CaiThienKhac" />
        </div>
      </div>

      <!-- Homework Fields -->
      <div class="row">
        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Bài tập về nhà' | translate }}</label>
          <ng-select [items]="homeWorkOptions"
                     [multiple]="true"
                     bindLabel="Ten"
                     bindValue="Id"
                     formControlName="HomeWork"
                     placeholder="{{ 'Chọn đánh giá' | translate }}">
          </ng-select>
        </div>

        <div class="col-6 mb-3">
          <label class="control-label">{{ 'Đánh giá khác' | translate }}</label>
          <input type="text" class="form-control" formControlName="BaiTapKhac" />
        </div>

        <div class="col-md-6 mb-3">
          <label class="control-label">{{ 'Đường dẫn bài tập' | translate }}</label>
          <input type="text" class="form-control" formControlName="LinkBaiTap" />
        </div>

        <div class="col-md-6 mb-3">
          <label class="control-label">{{ 'Đường dẫn Video' | translate }}</label>
          <input type="text" class="form-control" formControlName="LinkVideo" />
        </div>
      </div>

      <!-- General Comments Field -->
      <div class="row">
        <div class="col-12 mb-3">
          <label class="control-label">{{ 'Nhận xét chung' | translate }}</label>
          <textarea class="form-control" formControlName="NhanXetChung" rows="3"></textarea>
        </div>
      </div>

      <!-- Attachment Field -->
      <!-- Add this CSS class to the row containing the file uploader -->
      <div class="row">
        <div class="col-12 mb-3 control-fluid">
          <!-- Added control-fluid class here -->
          <label class="control-label">{{ 'Tệp đính kèm' | translate }}</label>
          <ejs-uploader #attachmentUploader
                        id="fileUploadSLL"
                        [asyncSettings]="path"
                        [multiple]="multiple"
                        [autoUpload]="autoUpload"
                        [dropArea]="dropElement"
                        (success)="onUploadSuccess($event)"
                        (removing)="onFileRemoved($event)"
                        (uploading)="onFileUploading($event)">
          </ejs-uploader>

          <!-- Display existing attachments if any -->
          <div *ngIf="uploadedFiles && uploadedFiles.length > 0" class="mt-2">
            <h6>{{ 'Uploaded Files' | translate }}</h6>
            <ul class="list-group">
              <li *ngFor="let file of uploadedFiles" class="list-group-item d-flex justify-content-between align-items-center">
                <span>{{file.name}}</span>
                <button type="button" class="btn btn-sm btn-danger" (click)="onFileRemoved({filesData: [{name: file.name}]})">
                  <i class="fa fa-times"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>


     
    </div>


  </div>
  <div class="modal-footer" style="display: flex;justify-content: space-between;">
    <div style="display:flex;">
      <div class="checkbox c-checkbox"> 
       
      </div>
    </div>

    <div class="">
      <a style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="cancel()" title="">{{ 'Hủy bỏ' | translate }}</a>
      
      <button type="button" class="btn btn-primary" (click)="saveData(1)" style="margin-right:5px;">
        {{ 'Lưu và gửi' | translate }}
      </button>
      <button type="button" class="btn btn-warning" (click)="saveData(0)">
        {{ 'Lưu' | translate }}
      </button>
    </div>

  </div>
</form>
